import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { Box, Container, Typography, Button, Stack } from "@mui/material";
import SEO from "../../components/SEO/SEO";
import { pageMeta } from "../../seo/pageMeta";

const NotFound = () => {
    const meta = pageMeta.notFound;

    return (
        <Box
            sx={{
                py: { xs: 10, md: 14 },
                minHeight: "calc(100vh - 200px)",
                textAlign: "center",
                background:
                    "linear-gradient(180deg, rgba(240,248,240,0.6) 0%, #ffffff 50%)",
            }}
        >
            <SEO {...meta} />
            <Container maxWidth="sm">
                <Typography
                    variant="h1"
                    component="h1"
                    sx={{
                        fontSize: { xs: "4rem", md: "5rem" },
                        fontWeight: 700,
                        color: "secondary.main",
                        mb: 2,
                    }}
                >
                    404
                </Typography>
                <Typography variant="h5" component="h2" sx={{ mb: 2 }}>
                    Page not found
                </Typography>
                <Typography
                    variant="body1"
                    color="text.secondary"
                    sx={{ mb: 4, lineHeight: 1.7 }}
                >
                    The page you are looking for does not exist. Explore Quran PDF
                    downloads, Surah Yaseen, or our Islamic learning blogs instead.
                </Typography>
                <Stack
                    direction={{ xs: "column", sm: "row" }}
                    spacing={2}
                    justifyContent="center"
                    alignItems="center"
                >
                    <Button component={RouterLink} to="/" variant="contained">
                        Back to Home
                    </Button>
                    <Button component={RouterLink} to="/blogs" variant="outlined">
                        Islamic Blogs
                    </Button>
                    <Button
                        component={RouterLink}
                        to="/quran-pdf-download"
                        variant="outlined"
                    >
                        Quran PDF
                    </Button>
                </Stack>
            </Container>
        </Box>
    );
};

export default NotFound;
